import { pushAnalyticsObjToDataLayer } from "@/utils/helper"
import {
  IMAGE_CLICK,
  IMAGE_SILDER,
  PLP,
} from "@/components/Shared/VisualNav/analytics/constant"
import {
  IMAGEID_DATALAYER_REGEX,
  VISUAL_NAV_IMAGEID_FOR_DATALAYER,
} from "@/constants/regex"
import { modifyHref } from "@/components/Shared/HeaderNavTabs/utils"

export const dataLayerForForArrows = (arrow = "") => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PLP}:${IMAGE_SILDER}:${arrow}`,
    eventMsg: "n/a",
    eventName: `${PLP}:${IMAGE_SILDER}:${arrow}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: `${arrow} arrow`,
    internalLinkPosition: PLP,
    internalLinkType: `${PLP}:${IMAGE_SILDER}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: `${PLP}:${IMAGE_SILDER}`,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const dataLayerForImageClick = (data = {}) => {
  const {
    isSlected = "false",
    index = -1,
    productLength = 0,
    title = "",
    imageUrl = "",
    link = "",
  } = data
  const selected = !isSlected ? "select" : "remove"
  const IndexReady = index + 1
  const datalayerRedayLink = link ? modifyHref(link) : ""
  const linkWithStart = datalayerRedayLink
    ? (datalayerRedayLink.indexOf("http") === -1
        ? window.location.origin
        : "") + datalayerRedayLink
    : "n/a"
  const getImageID = imageUrl => {
    if (imageUrl.startsWith("/content/dam")) {
      const imageID =
        imageUrl?.match(VISUAL_NAV_IMAGEID_FOR_DATALAYER)?.[1] || null
      const datalyerImageID = imageID ? imageID.split("_")[0] : null
      return datalyerImageID
    } else {
      const match = imageUrl.match(IMAGEID_DATALAYER_REGEX)
      if (match) {
        const extractedString = match[1]
        const datalayeReday = extractedString.split("_")[0]
        return datalayeReday
      }
    }
  }

  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${PLP}:${IMAGE_CLICK}:${selected}`,
    eventMsg: "n/a",
    eventName: `${PLP}:${IMAGE_CLICK}:${selected}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: title.toLowerCase(),
    internalLinkPosition: PLP,
    internalLinkType: `${PLP}:${IMAGE_SILDER}`,
    internalLinkURL: linkWithStart,
    internalLinkZoneName: `${PLP}:${IMAGE_SILDER}`,
    imageId: getImageID(imageUrl),
    imageName: title.toLowerCase(),
    imageSequence: `${IndexReady}_${productLength}`,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
